// Centralized page index for search functionality
// This ensures all pages are indexed on app load for first-time visitors

export const PAGE_SEARCH_INDEX = [
  {
    url: '/',
    terms: {
      mr: [
        'मुख्यपृष्ठ',
        'योजना',
        'उपक्रम',
        'कार्यक्रम',
        'पुरस्कार',
        'डॅशबोर्ड',
        'महाराष्ट्र कामगार कल्याण मंडळ',
        'MLWB',
        'कामगार',
        'कल्याण',
        'अधिकृत संकेतस्थळ',
        'कामगार कल्याण',
        'महाराष्ट्र राज्य',
        'कामगार विभाग',
        'शिस्त',
        'सेवा',
        'सुधार',
        'समृद्धी',
        'सर्वांगीण विकास',
        'जीवनमान उंचावणे',
        'स्वावलंबन',
        'कल्याणकारी उद्दिष्ट',
        'कल्याणकारी योजना',
        'शैक्षणिक योजना',
        'क्रीडा योजना',
        'सांस्कृतिक उपक्रम',
        'सामाजिक योजना',
        'आरोग्य सेवा',
        'रोजगारविषयक योजना',
        'उत्कृष्ट सुविधा',
        'आधुनिक केंद्रे',
        'नियोजनबद्ध सेवा',
        'सेवा सुविधा',
        'मुख्यमंत्री महाराष्ट्र',
        'उपमुख्यमंत्री महाराष्ट्र',
        'कामगार मंत्री',
        'राज्यमंत्री कामगार',
        'राज्य शासन',
        'सार्वजनिक प्रशासन',
        'सहकार्य',
        'सहभाग',
        'जनसहभाग',
        'सतत प्रगती'
      ],
      en: [
        'home',
        'schemes',
        'activities',
        'programs',
        'awards',
        'dashboard',
        'maharashtra labour welfare board',
        'MLWB',
        'labour',
        'welfare',
        'worker benefits',
        'official website',
        'labour welfare',
        'government of maharashtra',
        'labour department',
        'discipline',
        'service',
        'reform',
        'prosperity',
        'holistic development',
        'improving standard of living',
        'self-reliance',
        'welfare objective',
        'welfare schemes',
        'educational schemes',
        'sports schemes',
        'cultural activities',
        'social welfare programs',
        'health services',
        'employment schemes',
        'advanced facilities',
        'modern centres',
        'planned services',
        'service infrastructure',
        'chief minister of maharashtra',
        'deputy chief minister of maharashtra',
        'labour minister',
        'minister of state – labour',
        'state government',
        'public administration',
        'cooperation',
        'participation',
        'public participation',
        'continuous development'
      ]
    }
  },
  {
    url: '/overview',
    terms: {
      mr: [
        'आढावा',
        'मंडळ',
        'ब्रीद',
        'ध्येय',
        'कार्य',
        'गुणवत्ता धोरण',
        'परिचय',
        'प्रधान सचिव (कामगार)',
        'उपसचिव (कामगार)',
        'कल्याण आयुक्त',
        'कामगार मंत्री',
        'राज्यमंत्री (कामगार)',
        'प्रशासकीय अधिकारी',
        'महाराष्ट्र कामगार कल्याण मंडळ',
        'मुंबई कामगार कल्याण मंडळ',
        'कामगार कल्याण निधी',
        'स्वायत्त मंडळ',
        'वैधानिक मंडळ',
        'कामगार कल्याण केंद्र',
        'शासन नियुक्त मंडळ',
        'मुंबई कामगार कल्याण निधी अधिनियम १९५३',
        'कामगार कल्याण अधिनियम',
        'वैधानिक कायदा',
        'शासन अध्यादेश',
        'कलम ४',
        'उद्योग, ऊर्जा व कामगार विभाग',
        'मंडळाचे ब्रीद',
        'शिस्त',
        'सेवा',
        'सुधार',
        'समृद्धी',
        'मंडळाचे ध्येय',
        'सर्वांगीण विकास',
        'सामाजिक उन्नती',
        'मानसिक उन्नती',
        'आर्थिक विकास',
        'कल्याणकारी योजना',
        'कामगार सेवा',
        'कुटुंब कल्याण',
        'शैक्षणिक सुविधा',
        'क्रीडा सुविधा',
        'आरोग्य विषयक कार्यक्रम',
        'सांस्कृतिक कार्यक्रम',
        'सामाजिक कार्यक्रम',
        'रोजगार विषयक कार्यक्रम',
        'स्वयंरोजगार योजना',
        'इतर आधारित सेवा',
        'नोंदणीकृत कामगार',
        'औद्योगिक कामगार',
        'कामगार कुटुंब',
        'महिला प्रतिनिधी',
        'कामगार प्रतिनिधी',
        'मालक प्रतिनिधी',
        'अद्यावत ग्रंथालय',
        'वाचनालय',
        'कामगार वसाहत',
        'मैदानी खेळ',
        'आंतरगृह खेळ',
        'करमणूक कार्यक्रम',
        'मंडळाची बैठक',
        'अध्यक्ष',
        'सदस्य संख्या',
        '३ वर्षांचा कार्यकाळ',
        'नियोजनबद्ध आयोजन',
        'पद्धतशीर कार्य',
        'स्थापना १९५३',
        'नामांतर १९६०',
        'मुंबई राज्य',
        'महाराष्ट्र राज्याची स्थापना',
        'कामगार चळवळ',
        'स्वावलंबनाद्वारे विकास'
      ],
      en: [
        'overview',
        'board',
        'motto',
        'goal',
        'functions',
        'quality policy',
        'introduction',
        'principal secretary (labour)',
        'deputy secretary (labour)',
        'welfare commissioner',
        'labour minister',
        'minister of state – labour',
        'administrative officer',
        'maharashtra labour welfare board',
        'mumbai labour welfare board',
        'labour welfare fund',
        'autonomous board',
        'statutory board',
        'labour welfare centre',
        'government appointed board',
        'bombay labour welfare fund act, 1953',
        'labour welfare act',
        'statutory act',
        'government ordinance',
        'section 4',
        'industries, energy and labour department',
        'board motto',
        'discipline',
        'service',
        'reform',
        'prosperity',
        'board mission',
        'holistic development',
        'social upliftment',
        'mental well-being',
        'economic development',
        'welfare schemes',
        'worker services',
        'family welfare',
        'educational facilities',
        'sports facilities',
        'health programs',
        'cultural programs',
        'social programs',
        'employment programs',
        'self-employment schemes',
        'other support services',
        'registered Labours',
        'industrial Labours',
        'Labours\' families',
        'women representatives',
        'worker representatives',
        'employer representatives',
        'modern library',
        'reading room',
        'labour colony',
        'outdoor games',
        'indoor games',
        'recreational programs',
        'board meeting',
        'chairperson',
        'number of members',
        '3-year tenure',
        'planned implementation',
        'systematic operations',
        'established in 1953',
        'renamed in 1960',
        'bombay state',
        'formation of maharashtra state',
        'labour movement',
        'development through self-reliance'
      ]
    }
  },
  {
    url: '/administrative-structure',
    terms: {
      mr: [
        'प्रशासकिय रचना',
        'कल्याण आयुक्त',
        'उप कल्याण आयुक्त',
        'संघटन रचना'
      ],
      en: [
        'administrative structure',
        'welfare commissioner',
        'deputy welfare commissioner',
        'organizational structure'
      ]
    }
  },
  {
    url: '/board-members',
    terms: {
      mr: [
        'मंडळ सदस्य',
        'अधिकार',
        'कार्ये',
        'नियुक्ती',
        'अधिसूचना'
      ],
      en: [
        'board members',
        'powers',
        'functions',
        'appointment',
        'notification'
      ]
    }
  },
  {
    url: '/board-project',
    terms: {
      mr: [
        'मंडळ प्रकल्प',
        'प्रकल्प',
        'योजना',
        'मंडळातील केंद्राचे वर्गीकरण',
        'केंद्र प्रकार',
        'बहुउद्देशीय प्रकल्प',
        'उपकेंद्र',
        'स्वमालकीची जागा',
        'भाड्याची जागा',
        'कामगार क्रीडा भवन',
        'कामगार कल्याण भवन',
        'ललित कला भवन',
        'बहुउद्देशीय भवन',
        'समिती सभागृह',
        'खुले नाट्यगृह',
        'प्रभादेवी, मुंबई',
        'राजे रघुजी नगर, नागपूर',
        'सहकार नगर, पुणे',
        'मुंबई',
        'नागपूर',
        'पुणे',
        'ऑलिम्पिक दर्जाचा जलतरण तलाव',
        'क्रीडांगण',
        'मैदानी खेळ',
        'कबड्डी',
        'ऍथलेटिक्स',
        'खुले रंगमंच',
        'कुस्ती आखाडा',
        'बंदिस्त बॅडमिंटन कोर्ट',
        'टेबल टेनिस',
        'आंतरगृह खेळ',
        'व्यायामशाळा',
        'व्योमशाळा',
        'योगवर्ग',
        'सुसज्ज ग्रंथालय',
        'वाचनालय',
        'अभ्यासिका',
        'संगणक प्रशिक्षण वर्ग',
        'स्वयंरोजगार प्रशिक्षण',
        'फैशन डिझायनिंग',
        'शिवण वर्ग',
        'सरकार मान्य प्रशिक्षण',
        'शिशुमंदिर',
        'बालसंगोपन',
        'महिला प्रशिक्षण वर्ग',
        'सामाजिक उपक्रम',
        'मनोरंजनात्मक कार्यक्रम',
        'कामगार वसाहत',
        'वसाहतीतील कल्याणकार्य',
        'प्रासंगिक कार्यक्रम',
        'खेळ व स्पर्धा',
        'वर्षभरातील कार्यक्रम',
        'कामगार व कुटुंब',
        'कल्याणकारी उपक्रम',
        'सेवा उपलब्धता',
        'लाभार्थी'
      ],
      en: [
        'board project',
        'project',
        'scheme',
        'classification of board centres',
        'centre type',
        'multi-purpose project',
        'sub-centre',
        'owned premises',
        'rented premises',
        'Labours sports complex',
        'labour welfare building',
        'fine arts building',
        'multi-utility building',
        'committee hall',
        'open-air theatre',
        'prabhadevi, mumbai',
        'raje raghuji nagar, nagpur',
        'sahakar nagar, pune',
        'mumbai',
        'nagpur',
        'pune',
        'olympic-standard swimming pool',
        'sports ground',
        'outdoor games',
        'kabaddi',
        'athletics',
        'open stage',
        'wrestling arena',
        'indoor badminton court',
        'table tennis',
        'indoor games',
        'gymnasium',
        'fitness centre',
        'yoga classes',
        'well-equipped library',
        'reading room',
        'study room',
        'computer training class',
        'self-employment training',
        'fashion designing',
        'tailoring classes',
        'government-recognized training',
        'creche',
        'child care',
        'women training programs',
        'social activities',
        'recreational programs',
        'labour colony',
        'welfare activities in colonies',
        'occasional programs',
        'games and competitions',
        'annual programs',
        'labour and families',
        'welfare initiatives',
        'service availability',
        'beneficiaries'
      ]
    }
  },
  {
    url: '/annual-report',
    terms: {
      mr: [
        'वार्षिक गोषवारा',
        'वार्षिक अहवाल',
        'रिपोर्ट'
      ],
      en: [
        'annual report',
        'yearly report',
        'report'
      ]
    }
  },
  {
    url: '/circulars',
    terms: {
      mr: [
        'परिपत्रके',
        'कर्मचाऱ्यांसाठी परिपत्रके',
        'सूचना',
        'सेवानिवृत्त होणा-या कर्मचा-यांना काल्पनिक वेतनवाढ देण्याबाबत',
        'म.का.क.मंडळातील अधिकारी व कर्मचा-यांना वैयक्तिक संगणक खरेदी करण्यासाठी अग्रिम रक्कम मंजूर करणेबाबत',
        'मंडळातील अर्धवेळ कर्मचा-यांना विभागस्तरावर सेवामुक्त करण्याबाबत',
        'मत्ता व दायित्व विवरणपत्र सादर करण्याबाबत',
        'रोजनिशी दैनंदिनी बाबत',
        'वेतनश्रेणी कमाल टप्प्याच्या पुढे जात असेल',
        'शासकीय वाहन चालकांना देण्यात येणा-या अतिकालिक भत्त्यामध्ये वाढीबाबत',
        'संघटनेच्या पदाधिकाऱ्याना विशेष नैमित्तिक रजा मंजुरीबाबत',
        'सहायक कल्याण आयुक्त (संगणक) या प्रदान केलेले अधिकार',
        'सेवापुस्तिकेत नोंदीबाबत',
        'मंडळातील विभागप्रमुख व गटप्रमुख यांना प्रदान केलेले वित्तीय अधिकार',
        'महाराष्ट्र लोकसेवा हक्क अधिनियम, २०१५ अंतर्गत म.का.क.मंडळाच्या सेवा अधिसूचित झालेबाबत',
        'महाराष्ट्र कामगार कल्याण मंडळाचे अधिकार आणि कार्ये पार पाडण्यासाठी उप सचिव (कामगार-१०) यांच्या नियुक्तीबाबत',
        'कार्यमूल्यमापन अहवाल लिहिणे व जतन करणेबाबत',
        'सुरक्षारक्षक नेमण्याबाबत परिपत्रक',
        'परिपत्रक',
        'दावा प्रक्रिया',
        'घोषणा पत्र',
        'आय.आर.डी.ए. दावा - फॉर्म',
        'आय.आर.डी.ए. कॅशलेस फॉर्म'
      ],
      en: [
        'circulars',
        'circulars for employees',
        'notices',
        'regarding granting notional pay increments to employees who are retiring',
        'regarding sanctioning advance payment to officers and employees of the maharashtra labour welfare board for purchasing personal computers',
        'regarding relieving part-time employees of the board at the departmental level',
        'regarding submission of asset and liability statements',
        'regarding daily diary/logbook',
        'if the pay scale exceeds the maximum stage',
        'regarding increase in overtime allowance given to government vehicle drivers',
        'regarding sanctioning special casual leave to office bearers of the organization',
        'powers granted to the assistant welfare commissioner (computer)',
        'regarding entries in the service book',
        'financial powers granted to the heads of departments and group heads of the board',
        'regarding notification of services of the maharashtra labour welfare board under the maharashtra public services right to service act, 2015',
        'regarding the appointment of deputy secretary (labour-10) to perform the powers and functions of the maharashtra labour welfare board',
        'regarding writing and preserving performance evaluation reports',
        'circular regarding appointment of security guards',
        'circular',
        'claim process',
        'declaration form',
        'irda claim - form',
        'irda cashless form'
      ]
    }
  },
  {
    url: '/workers-welfare',
    terms: {
      mr: [
        'कामगार कल्याण निधी',
        'अधिनियम',
        'योगदान',
        'नोंदणी फॉर्म',
        'आस्थापना नोंदणी फॉर्म',
        'महाराष्ट्र कामगार कल्याण निधी भरण्यासाठी फॉर्म - ए-१',
        'अवितरित संचयनासाठी फॉर्म - सी',
        'वर्गणी',
        'महाराष्ट्र कामगार कल्याण निधी अधिनियम १९५३',
        'कलम ३',
        'कलम ६-अ (९)',
        'कलम ६ बब (6BB)',
        'कलम ७(२)',
        'कलम ८',
        'कायद्यामध्ये सुधारणा',
        'दंडाच्या रकमा',
        'अवितरित संचयन',
        'द्विपक्षीय / त्रिपक्षीय वर्गणी',
        'कामगारांचे अंशदान',
        'मालकांचे अंशदान',
        'शासन अंशदान',
        'ऐच्छिक देणग्या',
        'व्याजाची रक्कम',
        'वळती निधी',
        'कर्जाऊ रक्कम',
        'शासन मदत',
        'योगदान दर',
        'जुने दर',
        'सुधारित दर',
        'सहामाही अंशदान',
        'जून व डिसेंबर वेतन कपात',
        'जून २०२४ पासून लागू',
        'वेतन श्रेणी',
        'कारखाने अधिनियम १९४८',
        'बॉम्बे शॉप्स अँड एस्टॅब्लिशमेंट अॅक्ट १९४८',
        'मोटार वाहतूक कामगार कायदा',
        'दुकाने व आस्थापना',
        'औद्योगिक कारखाने',
        'निधीचा विनियोग',
        'सामुदायिक शिक्षण केंद्र',
        'वाचनालय',
        'ग्रंथालय',
        'शिशु मंदिरे',
        'शिशु संगोपनालय',
        'अभ्यासिका',
        'खेळ व खेळस्पर्धा',
        'सहली व सफरी',
        'मनोरंजनात्मक कार्यक्रम',
        'स्वयंरोजगार शिबिर',
        'व्यवसाय प्रशिक्षण',
        'सामाजिक कार्यक्रम',
        'जीवनमान सुधारणा',
        'मंडळ विश्वस्त',
        'निधी व्यवस्थापन',
        'कल्याणकारी कार्याची चौकट',
        'नियोजनबद्ध अंमलबजावणी',
        'कामगार कल्याण केंद्र',
        'एकूण २२६ केंद्रे',
        'सुसज्ज प्रकल्प',
        'मुंबई प्रकल्प',
        'नागपूर प्रकल्प',
        'पुणे प्रकल्प',
        'ग्रामीण केंद्रे',
        'आदिवासी विभागातील केंद्रे',
        'सहकारी साखर कारखाना परिसर',
        'समिती पद्धतीची केंद्रे',
        'उपकेंद्र',
        'कामगार क्रीडा भवन',
        'कामगार कल्याण भवन',
        'ललित कला भवन',
        'कामगार वसाहतीतील कल्याण कार्य',
        'प्रासंगिक कार्यक्रम',
        'नोंदणीकृत कामगार',
        'कामगार कुटुंब',
        'सामाजिक स्थिती सुधारणा',
        'राहणीमानाचा दर्जा',
        'कल्याणकारी उद्दिष्ट'
      ],
      en: [
        'labours welfare fund',
        'labours\' welfare fund',
        'Labours welfare fund',
        'act',
        'contribution',
        'registration form',
        'establishment registration form',
        'maharashtra labour welfare fund payment form - a-1',
        'undistributed accumulation form - c',
        'maharashtra labour welfare fund act, 1953',
        'labour welfare fund',
        'section 3',
        'section 6a(9)',
        'section 6bb',
        'section 7(2)',
        'section 8',
        'amendment to act',
        'penalty amounts',
        'unpaid accumulations',
        'tripartite contribution',
        'worker contribution',
        'employer contribution',
        'government contribution',
        'voluntary donations',
        'interest amount',
        'transferred funds',
        'loan amount',
        'government grant',
        'contribution rates',
        'old rates',
        'revised rates',
        'half-yearly contribution',
        'june & december salary deduction',
        'effective from june 2024',
        'salary slab',
        'factories act, 1948',
        'bombay shops and establishments act, 1948',
        'motor transport Labours act',
        'shops and establishments',
        'industrial factories',
        'utilization of fund',
        'community education centres',
        'reading room',
        'library',
        'creches',
        'child care centres',
        'study rooms',
        'sports and competitions',
        'excursions and tours',
        'recreational programs',
        'self-employment camps',
        'vocational training',
        'social welfare programs',
        'improvement of living standards',
        'board as trustee',
        'fund management',
        'framework of welfare activities',
        'planned implementation',
        'labour welfare centre',
        'total 226 centres',
        'fully equipped projects',
        'mumbai project',
        'nagpur project',
        'pune project',
        'rural centres',
        'tribal area centres',
        'cooperative sugar factory area',
        'committee-managed centres',
        'sub-centre',
        'Labours sports complex',
        'labour welfare building',
        'fine arts building',
        'welfare activities in labour colonies',
        'occasional programs',
        'registered Labours',
        'Labours\' families',
        'social upliftment',
        'standard of living',
        'welfare objective'
      ]
    }
  },
  {
    url: '/important-circulars',
    terms: {
      mr: [
        'महत्वाची परिपत्रके',
        'परिपत्रक',
        'मैदान आरक्षण',
        'शुल्क'
      ],
      en: [
        'important circulars',
        'circular',
        'ground reservation',
        'fees'
      ]
    }
  },
  {
    url: '/100-days-program',
    terms: {
      mr: [
        '१०० दिवस कार्यक्रम',
        'शंभर दिवस',
        'विशेष कार्यक्रम'
      ],
      en: [
        '100 days program',
        'hundred days',
        'special program'
      ]
    }
  },
  {
    url: '/right-to-info',
    terms: {
      mr: [
        'माहितीचा अधिकार',
        'RTI',
        'अर्ज',
        'माहिती',
        'माहितीचा अधिकार अधिनियम २००५',
        'जनमाहिती अधिकारी',
        'प्रथम अपिलिय अधिकारी',
        'महाराष्ट्र कामगार कल्याण मंडळ',
        'मध्यवर्ती कार्यालय',
        'विभागीय कार्यालये',
        'कार्यक्षेत्रानुसार',
        'अधिकारी नियुक्ती',
        'कलम ४ (ख) १६',
        'माहिती प्रसिद्ध',
        'आरटीआय अधिनियम'
      ],
      en: [
        'right to information',
        'RTI',
        'application',
        'information',
        'right to information act, 2005',
        'public information officer (pio)',
        'first appellate authority',
        'maharashtra labour welfare board',
        'head office',
        'divisional offices',
        'as per jurisdiction',
        'appointment of officers',
        'section 4(b)(16)',
        'information disclosure',
        'rti act'
      ]
    }
  },
  {
    url: '/right-to-service',
    terms: {
      mr: [
        'सेवेचा अधिकार',
        'RTS',
        'सेवा',
        'अर्ज',
        'कालबद्ध सेवा',
        'सेवा हक्क कायदा २०१५ अंतर्गत माहिती'
      ],
      en: [
        'right to service',
        'RTS',
        'service',
        'application',
        'time bound service',
        'information under the right to service act 2015'
      ]
    }
  },
  {
    url: '/tenders-notices',
    terms: {
      mr: [
        'निविदा',
        'सूचना',
        'टेंडर',
        'नोटिस',
        'निविदा जाहीर',
        'टेंडर फॉर्म',
        'बोली',
        'ऑनलाइन निविदा',
        'टेंडर सूचना',
        'नोटिफिकेशन'
      ],
      en: [
        'departmental tenders',
        'departmental tenders & notices',
        'tenders',
        'notices',
        'tender',
        'notice',
        'tender notice',
        'tender form',
        'bid',
        'bidding',
        'online tender',
        'tender notification',
        'public notice',
        'announcement'
      ]
    }
  },
  {
    url: '/photo-gallery',
    terms: {
      mr: [
        'फोटो',
        'गॅलरी',
        'छायाचित्रे',
        'वर्ष'
      ],
      en: [
        'photo',
        'gallery',
        'photos',
        'images',
        'year'
      ]
    }
  },
  {
    url: '/video-gallery',
    terms: {
      mr: [
        'व्हिडिओ',
        'गॅलरी',
        'व्हिडिओज',
        'वर्ष'
      ],
      en: [
        'video',
        'gallery',
        'videos',
        'year'
      ]
    }
  },
  {
    url: '/list-of-services',
    terms: {
      mr: [
        'सेवांची यादी',
        'सेवा',
        'योजना',
        'आर्थिक लाभ',
        'आर्थिक लाभाच्या योजना',
        'परिपत्रक',
        'फॉर्म',
        'अंतिम तारीख',
        'सर्वसाधारण शैक्षणिक अर्थसहाय्य योजना',
        'MPSC, UPSC आणि पीएच. डी अर्थसहाय्य योजना',
        'परदेश शैक्षणिक अर्थसहाय्य योजना',
        'क्रीडा अर्थसहाय्य योजना',
        'पाठ्यपुस्तक अर्थसहाय्य योजना',
        'शिवणयंत्र अनुदान योजना',
        'शासकीय संगणक टंकलेखन बेसिक कोर्स प्रमाणपत्र परीक्षा GCC-TBC आर्थिक सहाय्य योजना',
        'एम.एस.सी.आय.टी. सहाय्यता योजना',
        'गंभीर आजार वैद्यकीय उपचार सहायता योजना',
        'साहित्य प्रकाशन अनुदान योजना',
        'वाहन चालक प्रशिक्षण'
      ],
      en: [
        'list of services',
        'services',
        'schemes',
        'financial benefit',
        'Financial Benefit Schemes',
        'Circular',
        'Form',
        'Last Date',
        'General Educational Scholarship Scheme',
        'MPSC, UPSC And Ph.D Scholarship Scheme',
        'Foreign Higher Education Scholarship Scheme',
        'Sports Scholarship Scheme',
        'Financial Assistance for Purchase of Text Books',
        'Grant for the purchase of Sewing Machines scheme',
        'Government Computer Typing Basic Course Certificate Examination GCC-TBC Financial Assistance Scheme',
        'MS-CIT Financial Assistance scheme',
        'Financial assistance for critical illness treatment',
        'Literature Publication Grants Scheme',
        'Driver Training'
      ]
    }
  },
  {
    url: '/dashboard',
    terms: {
      mr: [
        'डॅशबोर्ड',
        'सदस्यत्व डेटा',
        'प्रतिष्ठान',
        'DBT योजना',
        'आकडेवारी',
        'नवीन प्रतिष्ठान डेटा',
        'एकूण सदस्य',
        'एकूण कुटुंबे',
        'तपशीलवार डेटा',
        'शाखा',
        'जिल्हा',
        'सदस्य',
        'कुटुंबे',
        'इतर',
        'एकूण',
        'अहमदनगर',
        'अकोला',
        'अमरावती',
        'बीड',
        'भंडारा',
        'बुलढाणा',
        'छत्रपती संभाजीनगर',
        'गडचिरोली',
        'हिंगोली',
        'जळगाव',
        'जालना',
        'नागपूर',
        'नांदेड',
        'परभणी',
        'पुणे',
        'वर्धा',
        'वाशीम',
        'यवतमाळ',
        'मुंबई',
        'नाशिक',
        'ठाणे'
      ],
      en: [
        'dashboard',
        'membership data',
        'establishments',
        'DBT scheme',
        'statistics',
        'Membership Data',
        'New Establishments Data',
        'DBT Scheme',
        'Total Members',
        'Total Families',
        'Branch',
        'District',
        'Members',
        'Families',
        'Others',
        'Total',
        'AHILYANAGAR',
        'AKOLA',
        'AMRAVATI',
        'BEED',
        'BHANDARA',
        'BULDHANA',
        'CHHATRAPATI SAMBHAJINAGAR',
        'GADCHIROLI',
        'HINGOLI',
        'JALGAON',
        'JALNA',
        'NAGPUR',
        'NANDED',
        'PARBHANI',
        'PUNE',
        'WARDHA',
        'WASHIM',
        'YAVATMAL',
        'Mumbai',
        'Nagpur',
        'Nashik',
        'Pune',
        'Thane'
      ]
    }
  },
  {
    url: '/contact',
    terms: {
      mr: [
        'संपर्क',
        'कार्यालये',
        'पत्ता',
        'फोन',
        'ईमेल',
        'नकाशा',
        'संपर्क करा',
        'हेल्पलाइन',
        'कॉल करा',
        'लोकेशन',
        'ऑफिस',
        'हेड ऑफिस',
        'महाराष्ट्र कामगार कल्याण मंडळ',
        'मुख्य कार्यालय',
        'प्रशासकीय इमारत',
        'हुतात्मा बाबू गेनू',
        'मुंबई गिरणी कामगार क्रीडा भवन',
        'सेनापती बापट मार्ग',
        'प्रभादेवी रेल्वे स्टेशनजवळ',
        'मुंबई',
        '४०० ०१३'
      ],
      en: [
        'contact',
        'offices',
        'address',
        'phone',
        'email',
        'map',
        'contact us',
        'helpline',
        'call',
        'location',
        'office',
        'head office',
        'reach us',
        'get in touch',
        'maharashtra labour welfare board',
        'administrative building',
        'hutatma babu genu',
        'mumbai mill labours sports building',
        'senapati bapat marg',
        'near prabhadevi railway station',
        'mumbai',
        '400013'
      ]
    }
  },
  {
    url: '/contact-sop',
    terms: {
      mr: [
        'संपर्क SOP',
        'ग्राहक सहायता',
        'संपर्क निर्देशिका',
        'कार्यालयीन वेळ',
        'अधिकारी',
        'विभाग',
        'ग्राहक सहायता ईमेल',
        'helpdeskmlwb@gmail.com',
        'ग्राहक सहायता फोन',
        'कार्यकाळ',
        'महाराष्ट्र कामगार कल्याण मंडळ',
        'मध्यवर्ती कार्यालय, मुंबई',
        'विभागीय / गट कार्यालय',
        'मुख्य कार्यालय',
        'विभागीय कार्यालये',
        'साप्ताहिक सुट्टी'
      ],
      en: [
        'contact sop',
        'customer support',
        'contact directory',
        'office hours',
        'officials',
        'department',
        'Customer Support',
        'Customer Support Email',
        'helpdeskmlwb@gmail.com',
        'Customer Support Phone',
        'Operating Hours',
        'Contact Directory',
        'Maharashtra Labour Welfare Board',
        'Central Office, Mumbai',
        'Divisional / Group Office',
        'Office Hours',
        'Head Office',
        'Divisional Offices',
        'Weekly Off'
      ]
    }
  },
  {
    url: '/sitemap',
    terms: {
      mr: [
        'साइट मॅप',
        'मुख्य पृष्ठे',
        'सेवा आणि संसाधने',
        'मीडिया आणि कार्यक्रम',
        'बाह्य लिंक्स्'
      ],
      en: [
        'site map',
        'main pages',
        'services and resources',
        'media and programs',
        'external links'
      ]
    }
  },
  {
    url: '/grievance',
    terms: {
      mr: [
        'तक्रार निवारण',
        'तक्रार',
        'निवारण',
        'अर्ज'
      ],
      en: [
        'grievance',
        'complaint',
        'redressal',
        'application'
      ]
    }
  },
  {
    url: '/privacy',
    terms: {
      mr: [
        'गोपनीयता',
        'अस्वीकरण',
        'धोरण',
        'माहिती',
        'संरक्षण',
        'कुकीज',
        'गोपनीयता धोरण',
        'माहिती संग्रह',
        'माहितीचा वापर',
        'माहिती संरक्षण',
        'कुकीज आणि ट्रॅकिंग',
        'बाह्य संकेतस्थळे / पोर्टल्सशी असलेल्या जोडण्या',
        'महाराष्ट्र कामगार कल्याणक मंडळ संकेतस्थळाशी इतर संकेतस्थळे / पोर्टल्स याद्वारे असलेल्या जोडण्या',
        'जलद जोडण्याविषयीची धोरणे',
        'स्वामित्व हक्क धोरण',
        'माहितीचे अधिकार',
        'उत्तरदायित्त्वास नकार',
        'सेवा उपलब्धता',
        'धोरणात बदल',
        'संपर्क माहिती'
      ],
      en: [
        'privacy policy',
        'privacy policy and disclaimer',
        'privacy',
        'disclaimer',
        'policy',
        'information',
        'protection',
        'cookies',
        'Privacy Policy',
        'Information Collection',
        'Use of Information',
        'Information Protection',
        'Cookies and Tracking',
        'Links to External Websites/Portals',
        'Links to the Maharashtra Labour Welfare Board Website by Other Websites/Portals',
        'Hyperlinking Policy',
        'Copyright Policy',
        'Information Rights',
        'Disclaimer',
        'Service Availability',
        'Policy Changes',
        'Contact Information'
      ]
    }
  },
  {
    url: '/faq',
    terms: {
      mr: [
        'वारंवार विचारले जाणारे प्रश्न',
        'प्रश्न',
        'उत्तरे',
        'सहाय्य',
        'मदत',
        'संपर्क',
        'महाराष्ट्र कामगार कल्याण निधी अधिनियम १९५३ कोणाला लागू आहे',
        '१९५३ अधिनियमानुसार कामगार म्हणजे कोण',
        'महाराष्ट्र कामगार कल्याण निधी म्हणजे काय',
        'आस्थापना / कंपनी यांनी मंडळाकडे नोंदणी करुन घेण्याची प्रक्रिया काय आहे',
        'कामगार कल्याण केंद्राच्या वेळा काय आहेत',
        'मंडळाच्या योजना, उपक्रम व कार्यक्रमांचा लाभ घेण्यासाठी कुठे संपर्क साधावा',
        'एका योजनेचा लाभ घेतल्यानंतर त्याच व्यक्तिला दुसऱ्या योजनेचे लाभ घेता येतो काय',
        'मंडळाच्या विविध कार्यक्रमांचे वेळापत्रक आहे काय',
        'गंभीर आजार उपचार सहाय्यता योजनेचा लाभ कुणाला मिळतो',
        'सर्वसाधारण शिष्यवृत्ती योजनेचा लाभ कुणाला मिळतो',
        'पाठ्यपुस्तक सहायता योजना म्हणजे काय',
        'गुणवंत कामगार कल्याण पुरस्कार कुणाला दिला जातो',
        'कामगार भूषण पुरस्कारासाठी कधी अर्ज करता येतो'
      ],
      en: [
        'faq',
        'questions',
        'answers',
        'help',
        'support',
        'contact',
        'Who does the Maharashtra Labour Welfare Fund Act 1953 apply to',
        'Who is considered a Labour under this act',
        'What is the Maharashtra Labour Welfare Fund',
        'What is the registration process for establishments/companies with the board',
        'What are the timings of Labour Welfare Centres',
        'Where to contact for availing benefits of board\'s schemes, programs and activities',
        'Can a person avail benefits of another scheme after availing one scheme',
        'Is there a schedule for various programs of the board',
        'Who gets benefits under the Serious Illness Treatment Assistance Scheme',
        'Who gets benefits under the General Scholarship Scheme',
        'What is the Textbook Assistance Scheme',
        'Who is given the Meritorious Labour Welfare Award',
        'When can one apply for the Labour Bhushan Award'
      ]
    }
  },
  {
    url: '/schemes',
    terms: {
      mr: [
        'योजना',
        'आर्थिक लाभ',
        'शिष्यवृत्ती',
        'अर्थसहाय्य'
      ],
      en: [
        'schemes',
        'financial benefit',
        'scholarship',
        'financial assistance'
      ]
    }
  },
  {
    url: '/activities',
    terms: {
      mr: [
        'उपक्रम',
        'शिशुमंदिर',
        'वाचनालय',
        'ग्रंथालय',
        'अभ्यासिका',
        'शिवण वर्ग',
        'व्यायामशाळा',
        'परिपत्रक',
        'फॉर्म',
        'दिनांक',
        'पाळणाघर',
        'हस्तव्यवसाय वर्ग',
        'शासनमान्य ग्रंथपालन प्रमाणपत्र शिक्षण वर्ग',
        'अन्य उपक्रम',
        'जलतरण तलाव',
        'बॅडमिंटन कोर्ट',
        'टेबल टेनिस कोर्ट',
        'जिम्नॅस्टीक वर्ग',
        'संगणक वर्ग',
        'ब्युटीपार्लर कोर्स',
        'नृत्य वर्ग',
        'टेक्निकल इन्स्टिट्यूट अभ्यासक्रम'
      ],
      en: [
        'activities',
        'children home',
        'reading room',
        'library',
        'study room',
        'sewing class',
        'gymnasium',
        'Activity',
        'Circular',
        'Form',
        'Date',
        'Children\'s Home',
        'Daycare',
        'Reading Room',
        'Library',
        'Study Room',
        'Sewing Class',
        'Handicraft Class',
        'Government Approved Library Science Certificate Course',
        'Other Activities',
        'Swimming Pool',
        'Gymnasium',
        'Badminton Court',
        'Table Tennis Court',
        'Gymnastics Class',
        'Computer Class',
        'Beauty Parlor Course',
        'Dance Class',
        'Technical Institute Course'
      ]
    }
  },
  {
    url: '/programs',
    terms: {
      mr: [
        'कार्यक्रम',
        'नाट्य महोत्सव',
        'साहित्य संमेलन',
        'भजन स्पर्धा',
        'लोकनृत्य',
        'कार्यक्रम',
        'परिपत्रक',
        'फॉर्म',
        'दिनांक',
        'राज्यस्तरीय कामगार साहित्य संमेलन',
        'कामगार नाट्य महोत्सव',
        'महिला नाट्य महोत्सव',
        'बाल नाट्य महोत्सव',
        'दशावतारी नाट्य महोत्सव',
        'नाट्य प्रशिक्षण शिबीर',
        'भजन स्पर्धा',
        'लोकनृत्य स्पर्धा',
        'समरगीत स्पर्धा',
        'राज्यस्तरीय भजन प्रशिक्षण शिबीर'
      ],
      en: [
        'programs',
        'theatre festival',
        'literature conference',
        'bhajan competition',
        'folk dance',
        'Program',
        'Circular',
        'Form',
        'Date',
        'State-Level labours\' Literature Conference',
        'Labours\' Theatre Festival',
        'Women\'s Theatre Festival',
        'Children\'s Theatre Festival',
        'Dashavatari Theatre Festival',
        'Theatre Training Camp',
        'Bhajan Competition',
        'Folk Dance Competition',
        'Patriotic Song Competition',
        'State-Level Bhajan Training Camp'
      ]
    }
  },
  {
    url: '/awards',
    terms: {
      mr: [
        'पुरस्कार',
        'विश्वकर्मा',
        'गुणवंत',
        'कामगार भूषण',
        'कामगार मित्र',
        'परिपत्रक',
        'फॉर्म',
        'दिनांक',
        'विश्वकर्मा आदर्श कामगार पुरस्कार',
        'गुणवंत कामगार पुरस्कार',
        'गुणवंत कामगार कल्याण पुरस्कार',
        'कामगार भूषण पुरस्कार',
        'वबहाददूर नारायण मेघाजी लोखंडे कामगार मित्र पुरस्कार'
      ],
      en: [
        'awards',
        'vishwakarma',
        'meritorious',
        'labour excellence',
        'labour friend',
        'Award',
        'Circular',
        'Form',
        'Date',
        'Vishwakarma Ideal Labour Award',
        'Meritorious labour Award',
        'Meritorious Labour Welfare Award',
        'Labour Excellence Award',
        'Raobahadur Narayan Meghaji Lokhande Labour Friend Award'
      ]
    }
  },
  {
    url: '/feedback',
    terms: {
      mr: [
        'अभिप्राय',
        'फीडबॅक',
        'सुधारणा',
        'सुझाव'
      ],
      en: [
        'feedback',
        'suggestion',
        'improvement',
        'comment'
      ]
    }
  },
  {
    url: '/screen-reader',
    terms: {
      mr: [
        'स्क्रीन रीडर',
        'एक्सेसिबिलिटी',
        'कीबोर्ड',
        'नेव्हिगेशन',
        'स्क्रीन रीडर सपोर्ट',
        'वेबसाइट एक्सेसिबिलिटी वैशिष्ट्ये',
        'शिफारस केलेले स्क्रीन रीडर्स',
        'ब्राउझर आणि कॉन्फिगरेशन टिप्स',
        'उपयुक्त कीबोर्ड शॉर्टकट',
        'विविध स्क्रीन रीडर्सशी संबंधित माहिती',
        'NVDA',
        'सिस्टम एक्सेस टू गो',
        'हाल',
        'JAWS',
        'सुपरनोव्हा'
      ],
      en: [
        'screen reader',
        'accessibility',
        'keyboard',
        'navigation',
        'Screen Reader Support',
        'Website Accessibility Features',
        'Recommended Screen Readers',
        'Browser & Configuration Tips',
        'Helpful Keyboard Shortcuts',
        'Information Related To The Various Screen Readers',
        'NVDA',
        'System Access To Go',
        'Hal',
        'JAWS',
        'Supernova'
      ]
    }
  },
  {
    url: 'https://mahatenders.gov.in/nicgep/app',
    terms: {
      mr: [
        'महाटेंडर्स',
        'महाराष्ट्र टेंडर',
        'टेंडर',
        'निविदा',
        'महा निविदा',
        'e-टेंडर'
      ],
      en: [
        'mahatenders',
        'maharashtra tenders',
        'tender',
        'e-tender',
        'online tender',
        'government tender'
      ]
    }
  },
  {
    url: 'https://gem.gov.in/',
    terms: {
      mr: [
        'GEM पोर्टल',
        'GEM',
        'जीईएम',
        'सरकारी ई-मार्केटप्लेस',
        'टेंडर',
        'निविदा'
      ],
      en: [
        'GEM portal',
        'GEM',
        'government e marketplace',
        'tender',
        'procurement',
        'online marketplace'
      ]
    }
  },
  {
    url: 'https://public.mlwb.in/public/UniversalApply',
    terms: {
      mr: [
        'अर्ज करा',
        'अर्ज',
        'ऑनलाइन अर्ज',
        'योजना अर्ज',
        'सेवा अर्ज',
        'आवेदन'
      ],
      en: [
        'apply here',
        'apply',
        'online application',
        'scheme application',
        'service application',
        'application form'
      ]
    }
  },
  {
    url: 'https://public.mlwb.in/public',
    terms: {
      mr: [
        'पब्लिक पोर्टल',
        'सार्वजनिक पोर्टल',
        'MLWB पोर्टल',
        'कामगार पोर्टल',
        'सेवा पोर्टल'
      ],
      en: [
        'public portal',
        'MLWB portal',
        'labour portal',
        'service portal',
        'citizen portal'
      ]
    }
  },
  {
    url: 'https://aaplesarkar.mahaonline.gov.in/',
    terms: {
      mr: [
        'आपले सरकार',
        'महाराष्ट्र सरकार',
        'सरकारी सेवा',
        'ऑनलाइन सेवा',
        'नागरिक सेवा'
      ],
      en: [
        'aaple sarkar',
        'maharashtra government',
        'government services',
        'online services',
        'citizen services'
      ]
    }
  }
];
